import React, { Component } from 'react'
import Snackbar from 'material-ui/Snackbar'
import { connect } from 'react-redux'

class AppBaseComponent extends Component {
	render() {
		return (
			<div className="grid-y medium-grid-frame">
				<div className="cell cell-block-container auto">
					<div className="grid-x">
						{ this.props.children }

						<Snackbar
							message={this.props.snackbar.message}
							open={this.props.snackbar.open}
							autoHideDuration={4000}
						/>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		snackbar: state.snackbar
	}
}

export default connect(mapStateToProps)(AppBaseComponent)


// WEBPACK FOOTER //
// ./src/application/templates/base.js